import { IPatientDevice } from '../../models/device';
import { IResult } from '../../models/result-models';
import {
    CLEAR_DEVICE_DETAILS_SUCCESS,
    LOAD_DEVICE_ERROR,
    LOAD_DEVICE_SUCCESS,
} from './device-actions';

interface LoadDeviceSuccessAction {
    type: 'LOAD_DEVICE_SUCCESS';
    result: IResult<IPatientDevice>;
}

interface LoadDeviceErrorAction {
    type: 'LOAD_DEVICE_ERROR';
    result: any;
}

interface IClearDeviceDetailsSuccessAction {
    type: 'CLEAR_DEVICE_DETAILS_SUCCESS';
}

type deviceKnownAction =
    | LoadDeviceSuccessAction
    | LoadDeviceErrorAction
    | IClearDeviceDetailsSuccessAction;

export const deviceReducer = (
    state: IResult<IPatientDevice> | null | undefined = null,
    action: deviceKnownAction
) => {
    switch (action.type) {
        case CLEAR_DEVICE_DETAILS_SUCCESS:
            return {
                ...state,
                ok: true,
                data: null,
            };
        case LOAD_DEVICE_SUCCESS:
            return action.result;
        case LOAD_DEVICE_ERROR: {
            const result: IResult<IPatientDevice> = {
                ok: false,
                message: action.result.message,
            };
            return result;
        }
        default:
            return state;
    }
};
